<div class="container">
  <div class="form-row">
    <div class="col-sm-4 pull-right text-right">
      <div *ngIf="!isLoading && formId" class="mct-flex row mct-justify-end mct-items-center mct-gap-27">
        <a [href]="formViewerUrl" [target]="'_blank'">{{ 'forms.form-builder.view-join-form' | translate | titlecase }}</a>
        <a [routerLink]="['/form-builder/form', formId, 'submissions']">{{ 'form-builder.view-submissions' | translate | titlecase }}</a>
      </div>
    </div>
    <h1>
      {{ 'forms.form-builder.title' | translate | titlecase }}
      <button
        app-add-button
        class="btn btn-primary"
        [label]="'forms.form-builder.form-settings.title' | translate | titlecase"
        [disabled]="isLoading"
        (click)="openEditSettingsWidget()"
      ></button>
    </h1>
  </div>
  <div class="form-row">
    <div class="col-sm-6" *ngIf="false">
      <label class="control-label"> {{ 'common.form' | translate | titlecase }} {{ 'common.name' | translate | titlecase }} </label>
      <input class="form-control" type="text" [(ngModel)]="formTemplate.Name" />
    </div>
    <div class="col-sm-6">
      <label class="control-label"> {{ 'common.form' | translate | titlecase }} {{ 'common.title' | translate | titlecase }} </label>
      <input class="form-control" type="text" [(ngModel)]="formTemplate.Title" />
    </div>
  </div>

  <div *ngIf="isLoading" class="col-sm-12">
    <wl-busy [show]="isLoading"></wl-busy>&nbsp;&nbsp;<span style="font-size: 18px">Loading Form</span>
  </div>

  <div class="col-sm-12">
    <hr />
  </div>
  <div class="form-row" *ngFor="let formGroup of formTemplate.FormGroups">
    {{ formGroup.name }}

    <div class="form-row" *ngFor="let formElement of formGroup.GroupElements; let i = index">
      <div class="col-sm-12 wl-show-on-hover-container">
        <div class="col-sm-5">
          <div class="col-sm-12 form-row">
            <label class="control-label">
              {{ formElement.LabelText }} <span [hidden]="!!!formElement.Required"> * </span>
              <i
                *ngIf="formElement.HelpText > ''"
                class="pi pi-question-circle"
                style="cursor: help; margin-left: 5px"
                [pTooltip]="formElement.HelpText"
                tooltipPosition="top"
              >
              </i>
            </label>
            <div
              *ngIf="
                !formElement.Field || (formElement.Field.DisplayAvailableValues.length == 0 && formElement.Field.DisplayValueType == 1)
              "
            >
              <input
                disabled
                class="form-control"
                type="text"
                [attr.maxlength]="formElement.Field.FieldLength"
                *ngIf="formElement.Field.ValueType == 1 && formElement.Field.IsSensitive == false"
              />
              <input
                disabled
                type="password"
                class="form-control"
                [attr.maxlength]="formElement.Field.FieldLength"
                *ngIf="formElement.Field.ValueType == 1 && formElement.Field.IsSensitive == true"
              />
            </div>
            <div
              *ngIf="formElement.Field && (formElement.Field.DisplayAvailableValues.length > 0 || formElement.Field.DisplayValueType == 9)"
            >
              <select disabled class="form-control">
                <option *ngFor="let item of formElement.Field.DisplayAvailableValues" [ngValue]="item.value">{{ item.Name }}</option>
              </select>
            </div>
            <div
              *ngIf="formElement.Field && (formElement.Field.DisplayAvailableValues.length > 0 || formElement.Field.DisplayValueType == 13)"
            >
              <select disabled class="form-control"></select>
            </div>
            <div *ngIf="formElement.Field.DisplayValueType == 2 || formElement.Field.DisplayValueType == 3">
              <input disabled type="number" class="form-control form-control-inline" min="0" />
            </div>
            <div *ngIf="formElement.Field.DisplayValueType == 4">
              <input disabled type="date" class="form-control form-control-inline" />
            </div>
            <div *ngIf="formElement.Field.DisplayValueType == 5">
              <input disabled type="checkbox" />
            </div>
            <div *ngIf="formElement.ElementTypeId == 7">
              <div>
                <wl-html-content-view [html]="formElement.Text"></wl-html-content-view>
              </div>
            </div>
            <div *ngIf="formElement.ElementTypeId == 8">
              <h1>{{ formElement.HeaderText }}</h1>
              <label>{{ formElement.SubHeaderText }}</label>
            </div>
            <div *ngIf="formElement.ElementTypeId == 9">
              <wl-form-builder-profile-display-element
                #relatedProfileDisplayElement
                [relatedProfileSettings]="formElement"
              ></wl-form-builder-profile-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 19">
              <wl-form-builder-profile-display-element [relatedProfileSettings]="formElement"></wl-form-builder-profile-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 10">
              <wl-form-builder-social-media-display-element
                [socialMediaSettings]="formElement"
              ></wl-form-builder-social-media-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 11">
              <wl-form-builder-listing-display-element
                #listingDisplayElement
                [listingSettings]="formElement"
              ></wl-form-builder-listing-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 13">
              <wl-form-builder-profile-address-display-element
                #profileAddressDisplayElement
                [profileAddressSettings]="formElement"
              ></wl-form-builder-profile-address-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 14">
              <wl-form-builder-hba-profile-data-display-element
                #hbaProfileDataDisplayElement
                [hbaProfileDataSettings]="formElement"
              ></wl-form-builder-hba-profile-data-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 16">
              <wl-form-builder-membership-level-display-element
                #membershipLevelSettingsDisplayElement
                [membershipLevelSettings]="formElement"
              ></wl-form-builder-membership-level-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 17">
              <wl-form-builder-affiliation-checklist-display-element
                [affiliationSettings]="formElement"
              ></wl-form-builder-affiliation-checklist-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 18">
              <wl-form-builder-upload-file-display-element [fileUploadSettings]="formElement"></wl-form-builder-upload-file-display-element>
            </div>
            <div *ngIf="formElement.ElementTypeId == 20">
              <wl-form-builder-email-optin-display-element [emailOptInData]="formElement"></wl-form-builder-email-optin-display-element>
            </div>
          </div>
        </div>
        <div class="col-sm-4 p-4">
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-default btn-sm" (click)="editFormElement(formElement)">
              {{ 'common.edit' | translate | titlecase }}
            </button>
            <button pButton type="button" class="atlas-btn atlas-btn-default btn-sm" (click)="removeFormElement(formElement, formGroup)">
              {{ 'common.remove' | translate | titlecase }}
            </button>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-default btn-sm"
              icon="pi pi-arrow-up"
              (click)="moveUp(formGroup, formElement)"
              *ngIf="formElement.Order > 1"
              [pTooltip]="('common.move' | translate | titlecase) + ' ' + ('common.up' | translate | titlecase)"
              tooltipPosition="top"
            ></button>

            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-default btn-sm"
              icon="pi pi-arrow-down"
              (click)="moveDown(formGroup, formElement)"
              *ngIf="formElement.Order < formGroup.GroupElements.length"
              [pTooltip]="('common.move' | translate | titlecase) + ' ' + ('common.down' | translate | titlecase)"
              tooltipPosition="top"
            ></button>
            <!--({{formElement.Order}})-->
          </div>
        </div>
        <div class="col-sm-2 p-4">
          <button
            app-add-button
            class="btn btn-primary wl-show-on-hover"
            [label]="
              ('common.new' | translate | titlecase) +
              ' ' +
              ('common.form' | translate | titlecase) +
              ' ' +
              ('common.element' | translate | titlecase)
            "
            (click)="openNewFormElementWidgetForIndex(i)"
          ></button>
        </div>
      </div>

      <div class="col-sm-12">
        <hr />
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <div class="col-sm-6">
        <button
          app-add-button
          class="btn btn-primary"
          [label]="
            ('common.new' | translate | titlecase) +
            ' ' +
            ('common.form' | translate | titlecase) +
            ' ' +
            ('common.element' | translate | titlecase)
          "
          (click)="openNewFormElementWidgets()"
        ></button>
      </div>
      <div class="col-sm-6"></div>
    </div>
  </div>
  <div class="col-sm-12">
    <hr />
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <button class="atlas-btn atlas-btn-primary" (click)="save()" *ngIf="formTemplate.FormGroups[0].GroupElements.length > 0">
        {{ 'common.save' | translate | titlecase }}
      </button>
    </div>
  </div>

  <wl-form-builder-edit-element #editFormElementModal (onChanges)="onEditChanges($event)"></wl-form-builder-edit-element>

  <p-dialog
    #newFormElementModal
    [(visible)]="showNewItemModal"
    modal="true"
    [closable]="false"
    styleClass="atlas-dialog-m"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      <h3>
        {{ 'common.add' | translate | titlecase }} {{ 'common.new' | translate | titlecase }} {{ 'common.form' | translate | titlecase }}
        {{ 'common.element' | translate | titlecase }}
      </h3>
    </ng-template>
    <div class="col-sm-12">
      {{ 'common.select' | translate | titlecase }} {{ 'common.form' | translate | titlecase }}
      {{ 'common.widget' | translate | titlecase }} {{ 'common.type' | translate | titlecase }}:
    </div>

    <div class="form-row">
      <div class="col-sm-12 mb-16">
        <select class="form-control" [ngModel]="selectedWidgetType" (ngModelChange)="onSelectedFormWidgetTypeChange($event)">
          <option *ngFor="let widgetType of availableFormWidgetTypes" [ngValue]="widgetType">{{ widgetType.Display }}</option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="col-sm-12 mb-16" *ngIf="selectedWidgetType.Value == 3">
        <label class="control-label"> {{ 'common.field' | translate | titlecase }} {{ 'common.type' | translate | titlecase }} </label>
        <select class="form-control" [ngModel]="selectedFormFieldGroup" (ngModelChange)="onSelectedFormFieldGroupChange($event)">
          <option *ngFor="let group of availableFormFieldGroups" [ngValue]="group">{{ group.DisplayName }}</option>
        </select>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 4">
        <div style="width: 100%">
          <label class="control-label">
            {{ 'common.field' | translate | titlecase }}
          </label>
        </div>
        <wl-form-builder-profile-edit-element #relatedProfileSettingsElement></wl-form-builder-profile-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup?.FieldGroupType === 14">
        <div style="width: 100%">
          <label class="control-label">
            {{ 'common.field' | translate | titlecase }}
          </label>
        </div>
        <wl-form-builder-profile-edit-element [isOrg]="true" #relatedOrgSettingsElement></wl-form-builder-profile-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 8">
        <wl-form-builder-listing-edit-element #listingSettingsElement></wl-form-builder-listing-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 2">
        <wl-form-builder-membership-level-edit-element #membershipLevelSettingsElement></wl-form-builder-membership-level-edit-element>
      </div>

      <div
        class="col-sm-12"
        *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && canSelectField(selectedFormFieldGroup.FieldGroupType)"
      >
        <label class="control-label">
          {{ 'common.field' | translate | titlecase }}
        </label>
        <select class="form-control" [ngModel]="selectedFormField" (ngModelChange)="onSelectedFormFieldChange($event)">
          <option *ngFor="let field of availableFormFields" [ngValue]="field">{{ field.DisplayName }}</option>
        </select>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 7">
        <div *ngFor="let socialMediaField of socialMediaSettings.SocialMediaFields">
          <div class="col-sm-6 mct-flex mct-col mb-12">
            <label>
              <input class="control-label" type="checkbox" [(ngModel)]="socialMediaField.Visible" /> {{ socialMediaField.Name }}
            </label>
            <input
              type="text"
              [(ngModel)]="socialMediaField.HelpText"
              placeholder="{{ 'common.placeholder-text' | translate | titlecase }}"
            />
          </div>
        </div>
      </div>

      <div class="col-sm-12" *ngIf="canBeRequired(selectedFormField.DisplayValueType)">
        <div class="form-row">
          <label>
            <input type="checkbox" [(ngModel)]="fieldIsRequired" />
            {{ 'common.required' | translate | titlecase }}
          </label>
        </div>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 11">
        <div style="width: 100%">
          <label class="control-label">
            {{ 'common.field' | translate | titlecase }}
          </label>
        </div>
        <wl-form-builder-profile-address-edit-element #profileAddressSettingsElement></wl-form-builder-profile-address-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 12">
        <div style="width: 100%">
          <label class="control-label">
            {{ 'common.field' | translate | titlecase }}
          </label>
        </div>
        <wl-form-builder-hba-profile-data-edit-element #hbaProfileDataSettingsElement></wl-form-builder-hba-profile-data-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && selectedFormFieldGroup.FieldGroupType == 13">
        <div style="width: 100%">
          <label class="control-label">
            {{ 'common.field' | translate | titlecase }}
          </label>
        </div>
        <wl-form-builder-upload-file-edit-element #fileUploadSettingsElement></wl-form-builder-upload-file-edit-element>
      </div>

      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 3 && selectedFormField && availableValues.length > 0">
        <label class="control-label">
          {{ 'common.value' | translate | titlecase }}
        </label>
        <select class="form-control" [ngModel]="selectedFieldValue" (ngModelChange)="onSelectedFormFieldValueChange($event)">
          <option *ngFor="let item of availableValues" [ngValue]="item">{{ item.Name }}</option>
        </select>
      </div>

      <div class="form-row">
        <div
          class="col-sm-12"
          *ngIf="selectedWidgetType.Value == 3 && selectedFormFieldGroup && canEditLabelText(selectedFormFieldGroup.FieldGroupType)"
        >
          <label class="control-label"> {{ 'common.label' | translate | titlecase }} {{ 'common.text' | translate | titlecase }} </label>
          <input class="form-control" type="text" [(ngModel)]="selectedLabelText" />
        </div>
      </div>

      <div class="form-row" *ngIf="selectedWidgetType.Value == 3 && selectedFormField && selectedFormField.DisplayValueType == 15">
        <wl-form-builder-affiliation-checklist-edit-element
          #affiliationCodeSettingsElement
        ></wl-form-builder-affiliation-checklist-edit-element>
      </div>

      <div *ngIf="selectedWidgetType.Value == 3 && selectedFormField && selectedFormField.DisplayValueType == 20">
        <wl-form-builder-email-optin-edit-element #emailOptInSettingsElement></wl-form-builder-email-optin-edit-element>
      </div>
      <!--revenue items price-->
      <div class="form-row" *ngIf="selectedFormField.FieldType == 85 && selectedFormField.FieldValue">
        <div class="col-sm-12">
          <label class="control-label">
            <input type="checkbox" [(ngModel)]="enableProration" />
            {{ 'forms.form-builder.revenue.enable-proration' | translate | titlecase }}
          </label>
        </div>
        <div class="ml-10 col-sm-12">
          <label class="control-label">
            {{ 'forms.form-builder.revenue.proration-month-text' | translate }}
            <p-select appendTo="body" [options]="monthItems" [(ngModel)]="selectedProrationMonth"></p-select>
          </label>
        </div>
        <div class="col-sm-12" [hidden]="!hasArc">
          <label class="control-label">
            <input type="checkbox" [(ngModel)]="useArc" />
            {{ 'forms.form-builder.revenue.use-arc' | translate | titlecase }}
          </label>
          <select
            class="form-control"
            [hidden]="!useArc || !availableArcs || availableArcs.length < 2"
            [required]="useArc"
            [(ngModel)]="selectedArc"
          >
            <option></option>
            <option *ngFor="let x of availableArcs" [ngValue]="x">
              {{ x.Descr }}
            </option>
          </select>
        </div>
        <div class="col-sm-12">
          <label class="control-label">
            {{ 'common.revenue.price' | translate | titlecase }}
          </label>
          <input
            class="form-control"
            type="number"
            [disabled]="useArc"
            placeholder="potentialFieldPrice"
            [(ngModel)]="selectedFieldPrice"
          />
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 2">
        <label class="control-label"> {{ 'common.display' | translate | titlecase }} {{ 'common.text' | translate | titlecase }} </label>
        <wl-wysiwyg-editor [showHtmlTemplates]="false" [disableImageSelector]="true" [(ngModel)]="selectedDisplayText"></wl-wysiwyg-editor>
      </div>
    </div>
    <div class="form-row">
      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 1">
        <label class="control-label"> {{ 'common.header' | translate | titlecase }} {{ 'common.text' | translate | titlecase }} </label>
        <input class="form-control" type="text" [(ngModel)]="selectedHeaderText" />
      </div>
    </div>
    <div class="form-row">
      <div class="col-sm-12" *ngIf="selectedWidgetType.Value == 1">
        <label class="control-label">
          {{ 'common.sub' | translate | titlecase }} {{ 'common.header' | translate | titlecase }}
          {{ 'common.text' | translate | titlecase }}
        </label>
        <input class="form-control" type="text" [(ngModel)]="selectedSubHeaderText" />
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        icon="pi pi-plus"
        [label]="'common.add' | translate | titlecase"
        (click)="addFormWidget()"
      ></button>
      <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancelNewFormElementWidgets()"> </cancel-button>
    </ng-template>
  </p-dialog>

  <p-dialog
    #formSettingsModal
    [(visible)]="showSettingsModal"
    modal="true"
    [closable]="false"
    styleClass="atlas-dialog-m"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      <h3>{{ 'forms.form-builder.form-settings.title' | translate | titlecase }}</h3>
    </ng-template>
    <wl-form-builder-settings
      #formSettingsComponent
      [(ngModel)]="formSettings"
      [(showEditor)]="showSettingsModal"
    ></wl-form-builder-settings>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        icon="pi pi-save"
        [label]="'common.done' | translate | titlecase"
        (click)="saveSettings()"
      ></button>
      <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancelEditSettings()"> </cancel-button>
    </ng-template>
  </p-dialog>
</div>
